/**
 * @fileoverview ProductoInventarioRepository - Repository for producto_inventario collection
 */

import { DataRepository, RepositoryError } from './base/DataRepository';
import type {
  ProductoInventario,
  CreateProductoInventarioData,
  UpdateProductoInventarioData,
} from '../types/collections/ProductoInventario';
import type { QueryOptions } from '../types/common/PocketBaseTypes';
import { createModuleLogger } from '../utils/logger';

/**
 * Repository for managing ProductoInventario records
 * Extends DataRepository with ProductoInventario-specific methods
 */
export class ProductoInventarioRepository extends DataRepository<ProductoInventario> {
  private logger = createModuleLogger('ProductoInventarioRepository');

  constructor() {
    super('producto_inventario');
  }

  /**
   * Get all active producto_inventario items
   * @returns Array of active ProductoInventario records sorted by nombre
   */
  async getAllActive(options: QueryOptions = {}): Promise<ProductoInventario[]> {
    try {
      const productos = await this.pb.collection(this.collectionName).getFullList<ProductoInventario>({
        filter: 'activo = true',
        sort: 'nombre',
        ...options,
      });

      this.logger.debug('Productos de inventario activos obtenidos', { count: productos.length });
      return productos;
    } catch (error) {
      throw new RepositoryError(
        `Error al obtener productos de inventario activos: ${error instanceof Error ? error.message : String(error)}`,
        'GET_ALL_ACTIVE_ERROR'
      );
    }
  }
}

